import { createRouter, createWebHistory } from "vue-router";

// Default Pages
import Home from "../views/Home.vue";

// Login Page
import Login from "../views/Login.vue";

// Portfolio Pages
import PresentProjectsList from "../views/Portfolio/PresentProjectsList.vue"
import PastProjectList from "../views/Portfolio/PastProjectsList.vue"
import NewProject from "../views/Portfolio/NewProject.vue"
import EditProject from "../views/Portfolio/EditProject.vue"

// Contact Page
import Contact from "../views/Contact.vue"

// layouts
import Blank from "../views/layouts/Blank.vue";

// error page
import Page404 from "../views/layouts/error/404.vue";
import Page500 from "../views/layouts/error/500.vue";
import ServerUnavailable from "../views/ServerUnavailable.vue";

import { useUserSignData } from "@/store/userSignData";

var appname = " | JestaGroup Dashboard";

const routes = [
  // Routes
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: { title: "Home " + appname, homePage: true },
  },

  // Portfolio Routes
  {
    path: "/portfolio/present-projects",
    name: "PresentProjectsList",
    component: PresentProjectsList,
    meta: { title: "Portfolio | Present Projects" + appname },
  },
  {
    path: "/portfolio/past-projects",
    name: "PastProjectList",
    component: PastProjectList,
    meta: { title: "Portfolio | Past Projects" + appname },
  },
  {
    path: "/portfolio/add",
    name: "NewProject",
    component: NewProject,
    meta: { title: "Portfolio | New Project" + appname },
  },  
  {
    path: "/portfolio/edit/:id",
    name: "EditProject",
    component: EditProject,
    meta: { title: "Portfolio | Edit Project" + appname },
  },

  // Contact Route
  {
    path: "/contact",
    name: "Contact",
    component: Contact,
    meta: { title: "Contact" + appname },
  },

  // layouts
  {
    path: "/Blank",
    name: "Blank Page",
    component: Blank,
    meta: { title: "Blank Page" + appname },
  },

  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: { title: "Login" + appname, hideNav: true, loginPage: true },
  },

  // layout/error
  // default page 404
  {
    path: "/:pathMatch(.*)*",
    name: "Page404",
    component: Page404,
    meta: { title: "Upps! 404" + appname, hideNav: true },
  },
  {
    path: "/ServerUnavailable",
    name: "ServerUnavailable",
    component: ServerUnavailable,
    meta: { title: "Server internal Error" + appname, hideNav: true },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,

  linkExactActiveClass: "exact-active",
});

router.beforeEach((to, from, next) => {
  const store = useUserSignData();

  console.log(store);

  document.title = to.meta.title;

  if (!store.isAuthenticated && to.path !== "/login") next("/login");
  else next();
});


export default router;
